import React from 'react';

const BedsTableEmptyMessage = () => {
    return (
        <div>
            No beds have been added yet. Select <b>Add bed</b> to proceed with creating or <b>Import the beds</b>.
        </div>
    );
};

export default BedsTableEmptyMessage;